import { render, staticRenderFns } from "./PortfolioFour.vue?vue&type=template&id=0d10adb9"
import script from "./PortfolioFour.vue?vue&type=script&lang=js"
export * from "./PortfolioFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports